<div [id]="mapBoxId" class="mapboxgl-map"></div>
